<template>
  <div>
    <el-alert
      title="按产品安全库存与可用库存的差额生成补货建议草稿。确认后仍走供应建议，生成采购到货草稿。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.suggestionCode" clearable placeholder="建议编号" style="width:180px" @keyup.enter.native="search" />
      <el-select v-model="query.suggestionState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已确认" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" @click="doGen">按安全库存生成</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="suggestionCode" label="建议编号" width="180" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.suggestionState === '01' ? 'success' : 'info'">{{ row.suggestionState === '01' ? '已确认' : '草稿' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column prop="createDate" label="创建时间" width="170" />
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewRow(row.suggestionId)">查看</el-button>
          <el-button type="text" :disabled="row.suggestionState !== '00'" @click="confirmRow(row.suggestionId)">确认</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.suggestionState !== '00'" @click="onDelete(row.suggestionId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="'最小库存补货 ' + (detail.suggestionCode || '')" :visible.sync="detailVisible" width="860px">
      <el-table :data="detail.lines || []" border size="small">
        <el-table-column type="index" width="50" />
        <el-table-column prop="productNumber" label="物料编码" width="140" />
        <el-table-column prop="productName" label="物料名称" min-width="140" />
        <el-table-column prop="requiredQty" label="安全库存" width="100" align="right" />
        <el-table-column prop="stockQty" label="可用库存" width="100" align="right" />
        <el-table-column prop="suggestQty" label="建议补货" width="100" align="right" />
      </el-table>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listMinStockReplenish, getMinStockReplenish, generateMinStockReplenish } from '../../api/minStockReplenish'
import { confirmSupplySuggestion, deleteSupplySuggestion } from '../../api/supplySuggestion'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { suggestionCode: '', suggestionState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      detailVisible: false, detail: {}
    }
  },
  created() { this.load() },
  methods: {
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listMinStockReplenish({
        currentPage: this.page, pageSize: this.pageSize,
        suggestionCode: this.query.suggestionCode, suggestionState: this.query.suggestionState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    doGen() {
      this.$confirm('将按产品安全库存与可用库存差额生成补货建议草稿，是否继续?', '提示', { type: 'warning' }).then(() => {
        generateMinStockReplenish().then(() => {
          this.$message.success('已生成补货建议')
          this.load()
        })
      }).catch(() => {})
    },
    viewRow(id) {
      getMinStockReplenish(id).then(res => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    confirmRow(id) {
      this.$confirm('确认该补货建议？', '提示', { type: 'warning' }).then(() => {
        confirmSupplySuggestion(id).then(() => { this.$message.success('已确认'); this.load() })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteSupplySuggestion([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
